import APIClient from '@/apiClient'
import { useRoute } from 'vue-router'
import moment from 'moment'; 

export const useRestStore = defineStore('rest', () => {
    const apiClient = new APIClient()
    const endpoints = ref(null)
    const version = ref('')
    const route = useRoute()
    const init = async () => {
        if(route.path.indexOf('auth') !== -1) return;
        let obj = await apiClient.get('rest/info', {})
        endpoints.value = obj.endpoints
    };

  return {
    init,
    endpoints,
    version
  }
})